import { readCache } from './api'
import { getMe, ownerDoesJobs } from './me'
import { todayISO } from './ui'

// Roundly opens on Today whenever today has work (Liam, 13 Oct 2026: "the point of the app is to keep on top of the
// work while you're working ... at the moment it opens onto Diary, and then I have to go to today"; "Whenever there is
// work"). Read off what this phone already holds, Today's saved day or the Diary's saved week, so opening never waits
// for signal. Work is a visit on today done or booked; a date only pencilled in (not agreed, suggested by Roundly or
// a week with no day) is not work yet, as a worker's downloaded day leaves it out (0038).

interface DayVisit {
  date?: string
  state?: string
  confirmed?: number
  source?: string | null
  deleted_at?: string | null
}

const PENCILLED = new Set(['suggested', 'tentative', 'week'])

export function isWork(v: DayVisit, day: string): boolean {
  if (v.deleted_at || (v.date !== undefined && v.date !== day)) return false
  if (v.state === 'done') return true
  return v.state === 'booked' && !(v.confirmed === 0 && PENCILLED.has(v.source ?? ''))
}

export function workToday(): boolean {
  const day = todayISO()
  const name = ownerDoesJobs() ? getMe()?.workerName?.trim() : null
  for (const key of [`today:everyone:${day}`, ...(name ? [`today:${name}:${day}`] : [])]) {
    const cleans = readCache<{ cleans?: DayVisit[] }>(key)?.data?.cleans
    if (cleans?.some((v) => isWork(v, day))) return true
  }
  const week = readCache<{ cleans?: DayVisit[] }>('schedule')?.data?.cleans
  return !!week?.some((v) => v.date === day && isWork(v, day))
}
